/*
 *
 * Websocket reducer
 *
 */

import produce from 'immer';
import { CLT_STATUS_RECEIVED, SCANNER_STATUS_RECEIVED, EDIT_CONTROL_LOCK_LIST, IBA_STATUS, FETCH_ARCHIVE_CLT_STATUS, ARCHIVE_CLT_STATUS_FINISHED } from './constants';
import ReconnectingWebSocket from './reconnecting-websocket';
import { DrawTwoTone } from '@mui/icons-material';

export const initialState = {
  cltStatusReceivedTimestamp: 0,
  scannerStatusReceivedTimestamp: 0,
  websocketObject: new ReconnectingWebSocket(`ws${window.location.protocol === 'https:' ? 's' : ''}://${window.location.host}/websocket/web/`),
  cltstatus: '',
  ibaStatus: '',
  latestCltstatus: '',
  archiveStatusLoading: false,
  editControlLocks: []
};

const websocketReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case CLT_STATUS_RECEIVED:
        draft.cltStatusReceivedTimestamp = new Date();
        draft.cltstatus = action.cltstatus;
        draft.latestCltstatus = action.cltstatus;
        break;
      case FETCH_ARCHIVE_CLT_STATUS:
        draft.archiveStatusLoading = true;
        break;
      case ARCHIVE_CLT_STATUS_FINISHED:
        draft.archiveStatusLoading = false;
        break;
      case IBA_STATUS:
        draft.ibaStatus = action.status;
      case SCANNER_STATUS_RECEIVED:
        draft.scannerStatusReceivedTimestamp = new Date();
        break;
      case EDIT_CONTROL_LOCK_LIST:
        draft.editControlLocks = action.list;
        break;
    }
  });

export default websocketReducer;
